<template>
  <div class="download-excel-report">
    <v-btn color="success" @click="downloadExcelReport" v-if="!running"><i class="material-icons">file_download</i> Excel Report</v-btn>
    <v-progress-circular indeterminate v-else />
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";

export default {
  name: "ExcelDownloadButton",
  data: () => {
    return {
      running: false
    }
  },
  props: ['view'],
  methods: {
    downloadExcelReport() {
      this.running = true;
      const params = {
        manufacturer: this.$store.getters.objAuthorize.manufacturer,
        date_from: this.$store.state.Dashboard.widgetConfig.dateRange.from.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.from : moment().subtract(3, 'months').format('YYYY-MM-DD'), //this.dateRange.from,
        date_to: this.$store.state.Dashboard.widgetConfig.dateRange.to.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.to : moment().endOf('day').format('YYYY-MM-DD'), //this.dateRange.to,
        metric: 'count',
        view: this.$store.state.Dashboard.widgetConfig.viewType,
        filters: this.$store.state.Dashboard.widgetConfig.filters,
        userId: this.$store.getters.objAuthorize.id,
        mode: 'excel'
      }

      switch (this.view) {
        case 'conversion':
          params.reporting_increment = this.$store.state.Dashboard.widgetConfig.periodType;
          break;
        case 'fulfillment':
          params.reporting_interval = this.$store.state.Dashboard.widgetConfig.intervalType
          break;
      }

      return Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
        params: {
          a: this.view,
          token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
          params
        }
      }).then(response => {
        this.running = false;
        return response.json();
      }, error => {
        console.log(error);
        alert('There was an error while trying to download the report');
      }).then(data => {
        // create dom element, and fake the click
        const reportDownload = document.createElement('a');
        reportDownload.setAttribute('href', data.data.file);
        reportDownload.setAttribute('download', 'quote_report.xlsx');
        reportDownload.click();
      }).catch((error) => {
        this.running = false;
        console.log(error);
        alert('There was an error while trying to download the report');
      });

    }
  }
}
</script>

<style scoped>

</style>
